


























import { Component, Prop, Vue } from 'vue-property-decorator'
import uploadSVG from '@/assets/img/asset-type-icons/upload.svg'

export type QuestionAttachment = {
  label?: string,
  url: string
}

@Component({
  components: {
  }
})

export default class SurveyQuestionAttachment extends Vue {
  @Prop({ required: true }) attachments!: QuestionAttachment[]

  thumbnail (attachment: QuestionAttachment) {
    let img = uploadSVG;
    ['png', 'jpg', 'jpeg', 'gif'].forEach(ext => {
      if (attachment?.url?.split('?')[0].slice((ext.length * -1)).toLowerCase() === ext) {
        img = attachment.url
      }
    })
    return img
  }
}
